module.exports = __webpack_public_path__ + "static/media/0072_Medium.6704ddd9.jpg";